import { get, post } from '@/api/core'
import { toBackendProductServiceCategory } from '@/helpers/productCategory'

export namespace compare {
  export type CompareMetricScore = {
    score?: number
    meanScore?: number
  }

  export type CompareProjectMetrics = {
    overallScore?: CompareMetricScore
    emotionScore?: CompareMetricScore
    cognitiveScore?: CompareMetricScore
    emrScore?: CompareMetricScore
    brandConnectionScore?: CompareMetricScore
    keyInformationScore?: CompareMetricScore
    interestingEnagementScore?: CompareMetricScore
    firstThreeScore?: CompareMetricScore
    lastThreeScore?: CompareMetricScore
    attentionForce?: CompareMetricScore
    emotionalForce?: CompareMetricScore
    messageForce?: CompareMetricScore
    brandForce?: CompareMetricScore
    persuasiveForce?: CompareMetricScore
    liking?: CompareMetricScore
    comprehension?: CompareMetricScore
    messageRelevance?: CompareMetricScore
    credibility?: CompareMetricScore
    newInformation?: CompareMetricScore
    uniqueness?: CompareMetricScore
    brandLinkage?: CompareMetricScore
    willingnessToLearnMore?: CompareMetricScore
    purchaseIntention?: CompareMetricScore
    shareability?: CompareMetricScore
    brandLikeabilityLift?: CompareMetricScore
    purchaseIntentionLift?: CompareMetricScore
  }

  export type CompareProject = ProjectModels.ProjectListItem & {
    metrics?: CompareProjectMetrics
  }

  export type DeletedProject = {
    projectId: number
    projectName: string
  }

  export type CompareReport = {
    id: number
    createdAt: number
    updatedAt: number
    creatorId: number
    corpId: string
    projectCategory: string
    reportName: string
    norm: 1 | 2
    projectCount: number
  }

  export type CompareReportDetail = CompareReport & {
    projects: CompareProject[]
    deletedProjects: DeletedProject[]
    metricNorms?: Record<keyof CompareProjectMetrics, number | undefined>
  }

  export function compareReportList(param: {
    projectCategory: ProjectModels.ProjectCategory
    keyword?: string
    pageNo: number
    pageSize: number
  }) {
    return get<{
      objects: CompareReport[]
      hasNext: boolean
      pageNo: number
      pageSize: number
      totalCount: number
    }>('/advert/compare/list', {
      projectCategory: toBackendProductServiceCategory(param.projectCategory),
      keyword: param.keyword,
      pageNo: param.pageNo,
      pageSize: param.pageSize,
    })
  }

  export function compareReportCreate(body: {
    projectCategory: ProjectModels.ProjectCategory
    reportName: string
    norm: 1 | 2
    projectIds: number[]
  }) {
    return post<{ data: CompareReportDetail }>('/advert/compare/add', {}, {
      ...body,
      projectCategory: toBackendProductServiceCategory(body.projectCategory),
    })
  }

  export function compareReportDetail(id: number) {
    return get<{ data: CompareReportDetail }>('/advert/compare/one', { id })
  }

  export function compareReportUpdate(body: {
    id: number
    reportName: string
    norm: 1 | 2
    projectIds: number[]
  }) {
    return post<{ data: CompareReportDetail }>('/advert/compare/update', {}, body)
  }

  export function compareReportDelete(id: number) {
    return post('/advert/compare/delete', {}, { id })
  }

  export function compareReportConfirmDeletedProjects(id: number) {
    return post<{ data: CompareReportDetail }>(
      '/advert/compare/confirm_deleted_projects',
      {},
      { id }
    )
  }
}
